export default {
  "product": {
    "product:autoMachineLearning": "Auto Machine Learning Platform",
    "product:modelDeployment": "AILM: Model Deployment",
    "product:anomalyDetection": "Anomaly Detection",
    "product:knowledgeManagement": "AILM: Knowledge Management",
    "product:adminService": "Admin Service",
    "product:onlineDeployment": "Online Deployment"
  },
  common: {
    profetAI: 'ProfetAI Inc.',
    welcome: 'Welcome Login',
    username: 'Username',
    onlineUsers: 'Online Users',
    password: 'Password',
    login: 'Login',
    submit: 'Submit',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    changeSucceeded: 'Succeede! Please login again',
  }, // common
  validate: {
    isRequired: '{0} is required.',
    notEqual: 'Password not equal',
    passValid: 'The string must contain at least 1 lowercase and uppercase alphabets, 1 number, and 10 characters or longer',
  }, // validate
  warning: {
    networkErr: 'Please check your network connection or try again later.',
  }, // warning
  serviceQuotaNotEnough: 'Run out of service quota. Please contact system adminstrator.',
  cannotConnectLicenseServer: 'Cannot connect license server, please check the network connection.',
  dbWrong: "Unknown error in database",
  WrongUserNameOrPassword: "Please enter the correct user name and password!",
  AccountIsDisabled: "{0} has been disabled, please contact administrators",
  RequiredPasswordChange: "Password must change.",
  RequireAccountAndPassword: "Account and Password are not null",
  NeedAdminRole: "Need Admin Role",
  userNotFound: "User not found",
  UnableToFindLicenseServer: "Cannot get license server location in database",
  UnableToFindTargetAccountService: "Cannot find target account/service",
  PasswordExpired: "Password expired, please reset password",
}